import { INTELLIGENCES } from 'schemas/intelligenceSchema';

export function useIntelligences() {
	//
	return { intelligences: INTELLIGENCES };
}
